import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React from "react";

function StepBar({ current, STEPS }) {
    const idx = STEPS.findIndex(s => s.key === current);
    return (
        <MDBox display="flex" alignItems="center" gap={0} mb={4}>
            {STEPS.map((s, i) => (
                <React.Fragment key={s.key}>
                    <MDBox display="flex" flexDirection="column" alignItems="center">
                        <MDBox
                            sx={{
                                width: 32,
                                height: 32,
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '0.875rem',
                                fontWeight: 'bold',
                                border: '2px solid',
                                transition: 'all 0.2s',
                                backgroundColor: i < idx ? '#49a3f1' : i === idx ? '#0A1B0C' : '#0A1B0C',
                                borderColor: '#fff',
                                color: '#fff',
                            }}
                        >
                            {i < idx ? '✓' : i + 1}
                        </MDBox>
                        <MDTypography
                            variant="caption"
                            sx={{
                                mt: 0.5,
                                whiteSpace: 'nowrap',
                                color: '#fff',
                                fontSize: '1rem'
                            }}
                        >
                            {s.label}
                        </MDTypography>
                    </MDBox>
                    {i < STEPS.length - 1 && (
                        <MDBox
                            sx={{
                                flex: 1,
                                height: 2,
                                mx: 1,
                                mb: 2.5,
                                backgroundColor: i < idx ? '#49a3f1' : 'gray',
                            }}
                        />
                    )}
                </React.Fragment>
            ))}
        </MDBox>
    );
}

export default StepBar;